import React, { useEffect } from "react";

import RightImg from "../../assets/images/login_side.png";
// import RightImg from "../../assets/images/login-page-bg.png";
import "./auth.css";
import LoginForm from "./LoginForm";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import { Typography } from "antd";
import RegisterForDemo from "./RegisterForDemo";
import ConfirmEmail from "./ConfirmEmail";
const { Text, Title } = Typography;

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    if (
      sessionStorage.getItem("token") &&
      !location.pathname.includes("reset-password") &&
      !location.pathname.includes("confirm_email")
    ) {
      history.push("/dashboard");
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="w40 login-left">
          <div className="w90">
            <Switch>
              <Route exact path="/">
                <LoginForm />
              </Route>
              <Route path="/reset-password">
                <ForgotPassword />
              </Route>
              <Route path="/set-password">
                <ForgotPassword />
              </Route>
              <Route path="/confirm_email">
                <ConfirmEmail />
              </Route>
              <Route exact path="/forgot-password/">
                <ResetPassword />
              </Route>
              <Route exact path="/request-demo">
                <RegisterForDemo />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="w60 login-right">
          <div className="mAuto w80">
            <Title level={3}>Expense Management for Growing Businesses</Title>
            <Text>Get control and visibility over all company expenses</Text>
            <img src={RightImg} alt="right_img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
